import { render, staticRenderFns } from "./BookmarkIcon.vue?vue&type=template&id=63e90628"
import script from "./BookmarkIcon.vue?vue&type=script&lang=js"
export * from "./BookmarkIcon.vue?vue&type=script&lang=js"
import style0 from "./BookmarkIcon.vue?vue&type=style&index=0&id=63e90628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports